// extracted by mini-css-extract-plugin
module.exports = {"bg":"App_bg_1QFyk","wrapper":"App_wrapper_pE_0j"};